<template>
    <div class="product-list">
     <!--搜索表单-->
     <div class="common-seach-wrap">
       <el-tabs v-model="activeName" @tab-click="handleClick">
         <el-tab-pane label="近七天数据" name="type_week"></el-tab-pane>
         <el-tab-pane label="近三十天数据" name="type_month"></el-tab-pane>
         <el-tab-pane label="近九十天数据" name="type_quarter"></el-tab-pane>
         <el-tab-pane label="近一年数据" name="type_years"></el-tab-pane>
         <el-tab-pane label="年度数据" name="type_year"></el-tab-pane>
         <el-tab-pane label="历史数据" name="type_history"></el-tab-pane>
         <el-tab-pane label="全部" name="typeall"></el-tab-pane>
       </el-tabs>
       <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
         <el-form-item label="用户昵称/ID/手机号"><el-input size="small" v-model="searchForm.keyword" 
            placeholder="用户昵称/ID/手机号"></el-input></el-form-item>
         <el-form-item>
            <el-date-picker v-if="activeName == 'type_year'" size="small" v-model="searchForm.year" type="year"  value-format="yyyy" 
             >
            </el-date-picker>
        </el-form-item>
         <el-form-item>
            
           <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
         </el-form-item>
       </el-form>
       <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       
       </el-form>
     </div>
 
 
     <!--内容-->
     <div class="product-content">
       <div class="table-wrap">
         <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"   >
     
           <el-table-column prop="supply_id" label="用户" width="200px">
             <template slot-scope="scope">
                <div class="name" >
                   <p>昵称：{{scope.row.nickName}}</p>
                   <p>ID：{{scope.row.user_id}}</p>
                 </div>
      
             </template>
           </el-table-column>
 
           <el-table-column prop="achievements" label="业绩" width="200px"></el-table-column>
    
           
         </el-table>
       </div>
     </div>
     <!--分页-->
     <div class="pagination">
       <el-pagination
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         background
         :current-page="curPage"
         :page-size="pageSize"
         layout="total, prev, pager, next, jumper"
         :total="totalDataNumber"
       ></el-pagination>
     </div>
 
   </div>
 </template>
 
 <script>
   import StatisticsApi from '@/api/statistics.js';
   export default{
     components:{
     },
     data(){
       return{
         /*是否正在加载*/
         activeName: 'type_week',
         loading: true,
         tableData:[],
         /*一页多少条*/
         pageSize: 10,
         /*一共多少条数据*/
         totalDataNumber: 0,
         /*当前是第几页*/
         curPage: 1,
         /*搜索参数*/
         searchForm: {
            keyword:"",
            year:""
         },
         /*数据对象*/
         dataModel:{}
       }
     },
     provide: function () {
       return {
         dataModel: this.dataModel
       }
     },
     created() {
 
       this.getData();
     },
     methods:{
       /*选择第几页*/
       handleCurrentChange(val) {
         let self = this;
         self.loading = true;
         self.curPage = val;
         self.getData();
       },
 
       /*每页多少条*/
       handleSizeChange(val) {
         this.pageSize = val;
         this.getData();
       },
 
       /*切换菜单*/
       handleClick(tab, event) {
         let self = this;
         self.curPage = 1;
         self.getData();
       },
       /*搜索查询*/
       onSubmit() {
         this.curPage = 1;
         this.getData();
       },
 
       /*获取数据*/
       getData() {
         let self = this;
         let Params = self.searchForm;
         Params.page = self.curPage;
         Params.list_rows = self.pageSize;
         Params.type = self.activeName;
         self.loading = true;
         StatisticsApi.getAchievement(Params, true)
           .then(res => {
             self.tableData = res.data.list.data;
             self.totalDataNumber = res.data.list.total;
             self.loading = false;
           })
           .catch(error => {});
       }
 
     }
   }
 </script>
 
 <style>
 </style>
 


// WEBPACK FOOTER //
// src/views/statistics/achievement/achievement.vue